import { Component, OnInit } from '@angular/core';
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    //CIERRA EL MENU/////////////////////////////////
    $('.navbar-nav>li>a>span').on('click', function() {
      $('.navbar-collapse').collapse('hide');

    });

    $('.navbar-nav>li>.dropdown-menu>a>span').on('click', function() {
      $('.navbar-collapse').collapse('hide');

    });
    /////////////////////////////////////////////////
  }

}
